import * as actions from 'store/auth/actions';
import NavigationService from 'services/navigation/NavigationService';
import { ROUTES } from 'router/routes';

import { TOKEN_KEY } from './TokenService';

export function initAuthStorageSync(store) {
  window.addEventListener('storage', (event) => {
    if (event.key !== TOKEN_KEY) return;

    if (!event.newValue && event.oldValue) {
      NavigationService.navigateToPath(ROUTES.signOut.path);
    } else {
      store.dispatch(actions.syncSession());
    }
  });
}
